module.exports = __webpack_public_path__ + "img/icon_restart.588e0fab.svg";